// @flow
import * as React from 'react';
import FieldSwitch from 'components/atoms/FieldSwitch';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

import { Col, Row } from 'reactstrap';
import QuestionsArea from 'components/atoms/QuestionsArea/';

import './AdditionalQuestions.scss';

export type Props = {
  appointmentStatus: string,
  callbackRequired: boolean,
  setCallBack: (callBack: boolean) => Object,
  textareaRef: string,
  flagValidator: boolean,
  notes: string,
  intl: IntlShape,
  isDmsAppt: boolean
};

type State = {
  isUserWantCall: boolean
};

export default class AdditionalQuestions extends React.Component<Props, State> {
  static block = 'additional-questions';
  static questionsAreaId = 'mobile-questions-area';

  constructor(props: Props) {
    super(props);
    (this: any).textInput = element => {
      this.textInput = element;
    };
    this.state = {
      isUserWantCall: true
    };
  }

  checkUserNoCall = () => {
    const { callbackRequired, notes } = this.props;
    if (notes && this.state.isUserWantCall && callbackRequired)
      this.setState({ isUserWantCall: false });
  };

  onChangeSwitch = (callBack: boolean) => {
    const { setCallBack } = this.props;
    setCallBack(!callBack);
  };

  fieldSwitch = () => {
    const { callbackRequired, intl, isDmsAppt } = this.props;
    return (
      <FieldSwitch
        name="callBack"
        label={intl.formatMessage({
          id: 'c8.review.want.us.to.call.you'
        })}
        onChange={() => this.onChangeSwitch(callbackRequired)}
        checked={callbackRequired}
        onClick={() => this.checkUserNoCall()}
        disabled={isDmsAppt}
      />
    );
  };

  textInput: React.Ref<'input'>;

  render() {
    const ns = AdditionalQuestions.block;
    const { isDmsAppt } = this.props;

    return (
      <div className={ns}>
        <QuestionsArea
          id={AdditionalQuestions.questionsAreaId}
          htmlRef={this.textInput}
          disabled={isDmsAppt}
        />
        <Row>
          <Col>{this.fieldSwitch()}</Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/AdditionalQuestions/AdditionalQuestions.js